export interface IPendencies {
	kycs: number
	deposits: number
	withdrawals: number
}
export class Pendencies implements IPendencies {
	kycs: number = 0
	deposits: number = 0
	withdrawals: number = 0
}


// WEBPACK FOOTER //
// ./src/models/pendencies.ts